import React from 'react';

const Icon = ({ size, ...otherProps }) => {
	const props = {
		width: size,
		height: size,
		fill: 'currentcolor',
		...otherProps,
	};
	return (
		<svg viewBox="0 0 24 24" {...props}>
			<path d="M7 10l5 5 5-5z" />
			<path d="M0 0h24v24H0z" fill="none" />
		</svg>
	);
};

export const ArrowDropDown = Icon;

ArrowDropDown.defaultProps = {
	size: 24,
};
